import {styled} from "@mui/material/styles"

const NoBorderButton = styled("button")`
    cursor: pointer;
    border: none;
    padding: 0;
    background: transparent;
    -webkit-tap-highlight-color: transparent;
`

export const FiltersMenuButton = styled(NoBorderButton)`
    width: 100%;
    height: 3.5rem;
    color: ${({theme}) => theme.colours.palette.text.primary};
    font-size: ${({theme}) => theme.colours.components.buttonLarge.fontSize};
    font-family: ${({theme}) => `${theme.colours.components.buttonLarge.fontFamily}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.components.buttonLarge.fontWeight};
    letter-spacing: ${({theme}) => theme.colours.components.buttonLarge.letterSpacing};
    line-height: ${({theme}) => theme.colours.components.buttonLarge.lineHeight};
    text-transform: ${({theme}) => theme.colours.components.buttonLarge.textTransform};
    display: flex;
    align-items: center;
    justify-content: center;
`
export const FilterIcon = styled("img")`
    color: ${({theme}) => theme.colours.text.default};
    height: 1rem;
    margin-right: 0.5rem;
`
